/* Made in Andhra — growth layer (Oct 2026).
   1. "Complete the look" upsell in the slide-out bag, tied to the free-shipping goal.
   2. Scroll-reveal for home sections (respects reduced motion, never hides content without JS).
   Original code. Depends only on window.MIA (mia-sky.js) and the Shopify AJAX cart API. */
(function () {
  'use strict';
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfg = window.MIA_CFG || {};
  var UPSELL = window.MIA_UPSELL || [];
  function money(c) { var v = (c / 100).toFixed(2); return (cfg.money || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, v); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  var cache = {}, busy = false, last = '';
  function getProduct(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch(R + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { cache[h] = p; return p; }).catch(function () { return null; });
  }
  function renderUpsell() {
    var items = document.getElementById('m-cart-items'); if (!items || busy || !UPSELL.length) return;
    busy = true;
    fetch(R + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var box = document.getElementById('m-upsell');
      if (!box) { box = document.createElement('div'); box.id = 'm-upsell'; box.className = 'm-upsell'; items.parentNode.insertBefore(box, items.nextSibling); }
      if (!c.items.length) { box.hidden = true; box.innerHTML = ''; last = ''; return; }
      var inCart = c.items.map(function (i) { return i.handle; });
      var pick = UPSELL.filter(function (h) { return inCart.indexOf(h) === -1; })[0];
      if (!pick) { box.hidden = true; box.innerHTML = ''; last = ''; return; }
      return getProduct(pick).then(function (p) {
        if (!p || !p.available) { box.hidden = true; return; }
        var avail = p.variants.filter(function (v) { return v.available; });
        var key = pick + ':' + c.total_price;
        if (key === last && box.innerHTML) { box.hidden = false; return; }
        last = key;
        var gap = (cfg.freeShip || 0) - c.total_price;
        var nudge = cfg.freeShip > 0 && gap > 0 && p.price >= gap ? 'Adding it unlocks free US shipping.' :
                    (cfg.freeShip > 0 && gap > 0 ? 'Gets you ' + money(Math.min(p.price, gap)) + ' closer to free US shipping.' : 'Pairs with everything in Drop 01.');
        var label = (p.options && p.options[0] && p.options[0].name) || 'Option';
        var sel = avail.length > 1 ? '<label class="m-sr" for="m-up-v">' + esc(label) + '</label><select id="m-up-v" class="m-upsell__sel">' +
          avail.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title.split(' / ')[0]) + '</option>'; }).join('') + '</select>'
          : '<input type="hidden" id="m-up-v" value="' + avail[0].id + '">';
        box.innerHTML = '<p class="m-upsell__eb">Complete the look</p>' +
          '<div class="m-upsell__row"><a href="' + p.url + '" class="m-upsell__img">' + (p.featured_image ? '<img src="' + img(p.featured_image, 200) + '" alt="" loading="lazy" width="64" height="80">' : '') + '</a>' +
          '<div class="m-upsell__bd"><a href="' + p.url + '" class="m-upsell__t">' + esc(p.title.replace(/^MADE IN ANDHRA™ — |^Made in Andhra™ /, '')) + '</a>' +
          '<span class="m-upsell__p">' + money(p.price) + '</span><span class="m-upsell__n">' + esc(nudge) + '</span></div></div>' +
          '<div class="m-upsell__act">' + sel + '<button type="button" class="m-btn m-upsell__btn" data-m-upsell-add>Add</button></div>';
        box.hidden = false;
      });
    }).catch(function () {}).then(function () { busy = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-m-upsell-add]'); if (!b) return;
    var v = document.getElementById('m-up-v'); if (!v) return;
    b.disabled = true; b.textContent = 'Adding…';
    fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +v.value, quantity: 1 }] }) })
      .then(function () { last = ''; return window.MIA && MIA.cart ? MIA.cart.refresh() : null; })
      .catch(function () { b.disabled = false; b.textContent = 'Add'; });
  });
  function watchCart() {
    var items = document.getElementById('m-cart-items'); if (!items) return;
    new MutationObserver(function () { renderUpsell(); }).observe(items, { childList: true });
  }

  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var main = document.getElementById('MainContent'); if (!main) return;
    var secs = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section')).slice(1);
    if (!secs.length) return;
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    secs.forEach(function (s) {
      if (s.getBoundingClientRect().top < vh) return;
      s.classList.add('mia-rv'); io.observe(s);
    });
  }

  function init() { watchCart(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
